import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fail-request',
  templateUrl: './fail-request.component.html',
  styleUrls: ['./fail-request.component.scss']
})
export class FailRequestComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FailRequestComponent>) { }

  ngOnInit(): void {
  }
}